import { render, staticRenderFns } from "./CombatCardWeapon.vue?vue&type=template&id=15e97bea&scoped=true&"
import script from "./CombatCardWeapon.vue?vue&type=script&lang=js&"
export * from "./CombatCardWeapon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e97bea",
  null
  
)

export default component.exports